/**
* Featured Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Services component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

( function( app ) {
  const COMPONENT = {
    className: 'featured-services',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      $( document ).ready( function() {
        const $slider = $( '.featured-service__slider' );

        $slider.slick( {
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        } );

        // Ensure the back arrow is hidden on page load
        function hideBackArrowOnFirstSlide() {
          if ( $slider.slick( 'slickCurrentSlide' ) === 0 ) {
            $( '.featured-services__prev' ).addClass( 'is-hidden' );
          } else {
            $( '.featured-services__prev' ).removeClass( 'is-hidden' );
          }
        }

        // Call the function immediately after Slick initialization
        $slider.on( 'init', function() {
          hideBackArrowOnFirstSlide();
        } );

        // Hide the back arrow if the first slide is active after sliding
        $slider.on( 'afterChange', function( event, slick, currentSlide ) {
          if ( currentSlide === 0 ) {
            $( '.featured-services__prev' ).addClass( 'is-hidden' );
          } else {
            $( '.featured-services__prev' ).removeClass( 'is-hidden' );
          }
        } );

        // Ensure the arrow visibility is correct after slider and DOM load
        $( window ).on( 'load', function() {
          hideBackArrowOnFirstSlide();
        } );

        // Custom arrow controls
        $( '.featured-services__prev' ).on( 'click', function() {
          $slider.slick( 'slickPrev' );
        } );

        $( '.featured-services__next' ).on( 'click', function() {
          $slider.slick( 'slickNext' );
        } );

        // Tab-based filtering
        const tabs = document.querySelectorAll( '.tabs .tab' );
        tabs.forEach( ( tab ) => {
          tab.addEventListener( 'click', function() {
            const category = this.getAttribute( 'data-category' );
            tabs.forEach( ( t ) => t.classList.remove( 'active' ) );
            this.classList.add( 'active' );
            filterSlides( category );
          } );
        } );

        function filterSlides( category ) {
          $slider.slick( 'slickUnfilter' );
          $slider.slick( 'slickFilter', function() {
            const slideCategory = $( this ).data( 'category' );
            return slideCategory === category;
          } );

          $slider.slick( 'slickGoTo', 0 );

          updateArrowsVisibility();
        }

        function updateArrowsVisibility() {
          setTimeout( () => {
            const slideCount = $slider.slick( 'getSlick' ).$slides.filter( ':visible' ).length;
            if ( slideCount < 5 ) {
              $( '.featured-services__prev, .featured-services__next' ).css( 'visibility', 'hidden' );
            } else {
              $( '.featured-services__prev, .featured-services__next' ).css( 'visibility', 'visible' );
            }
          }, 0 );
        }

        const activeTab = document.querySelector( '.tabs .tab.active' );
        if ( activeTab ) {
          const initialCategory = activeTab.getAttribute( 'data-category' );
          filterSlides( initialCategory );
        }
      } );
    },
    finalize: function() {},
  };

  // Register the component
  app.registerComponent( 'featured-services', COMPONENT );
} )( app );
